<template>
  <section>
    <div
      class="hidden md:flex z-40 top-40 right-4 flex-col gap-5 mr-2 fixed"
      style="direction: rtl"
      v-if="actions"
    >
      <a
        :key="index"
        :href="item.action_to"
        :target="item.new_tab ? '_blank' : ''"
        class="item"
        v-for="(item, index) in actions"
        @mouseover="handleMouseOver(index)"
      >
        <div class="icon-container">
          <i :class="'gg-' + (item.icon || 'link')" style="color: #ffff"></i>
        </div>
        <p v-show="activeIndex === index">{{ item.text || "Know more" }}</p>
      </a>
    </div>
  </section>
</template>
 
<script>
export default {
  data() {
    return {
      actions: this.$page.props.actions,
      activeIndex: -1,
    };
  },
  methods: {
    handleMouseOver(index) {
      this.activeIndex = index;
    },

    getActions() {
      const paramsString = this.buildQueryParams();

      this.axios.get(`/get-actions?route=${paramsString}`).then((response) => {
        this.actions = response.data.actions;
      });
    },

    getCurrentRoute() {
      const currentRoute = window.location.pathname;
      return currentRoute.split("/").filter(Boolean);
    },

    buildQueryParams() {
      const currentRouteArray = this.getCurrentRoute();

      return currentRouteArray.join("/");
    },
  },
  mounted() {
    this.getActions();
  },
};
</script>

<style>
:root {
  --ggs: 1.2;
}
.item {
  width: 56px;
  display: flex;
  align-items: center;
  background: #492280;
  border-radius: 3rem;
  transition: all 0.5s ease-in-out;
  cursor: pointer;
  justify-content: space-between;
  padding-left: 20px;
  border: 1px solid #2f0f5c;
}

.item:hover {
  min-height: 56px;
  border-radius: 0.5rem;
  transition: opacity 0.5s ease-in-out;
  max-width: 350px;
  width: 100%;
}

.item:not(:hover) {
  height: 56px;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 30px;
  min-height: 30px;
  margin-right: 12px;
}

.item p {
  width: 100%;
  opacity: 0;
  font-size: 18px;
  color: white;
  font-weight: 900;
  text-align: left;
  padding-right: 10px;
}

.item:hover p {
  display: block;
  opacity: 1;
}
</style>